// extracted by mini-css-extract-plugin
export default {"info":"cr7VLisz8v","h-rule":"_6k5YWITi4L","hRule":"_6k5YWITi4L","logo":"ds4sJvokTA","further-resources":"SaSTwHfdFI","furtherResources":"SaSTwHfdFI"};